import React from "react";
import ReactDOM from "react-dom/client"; 
import App from './App';
import './index.css';
import { HashRouter } from 'react-router-dom';

const rootElement = document.querySelector('#root');

const root = ReactDOM.createRoot(rootElement);

root.render(
  <React.StrictMode>
    <HashRouter>
      <App />
    </HashRouter>
  </React.StrictMode>
);
